@if (ProposalRequestFormGroup) {
  <form class="container-fluid p-0" [formGroup]="ProposalRequestFormGroup">
    <!-- Bid dates -->
    <div class="row mb-3">
      <div class="col">
        <app-display-card [innerPanel]="true">
          <div class="qsb-section-head">
            <h3 class="mb-0">Bid dates</h3>
          </div>
          <div class="row g-3">
            <div class="col-md-4">
              <div class="form-group">
                <label class="form-label" for="qsb-reminderDate">
                  Reminder date
                </label>
                <div class="input-group">
                  <input
                    id="qsb-reminderDate"
                    class="form-control"
                    type="text"
                    placeholder="mm/dd/yyyy"
                    (ngModelChange)="bidReminderDateChanged()"
                    formControlName="reminderDate"
                    ngbDatepicker
                    container="body"
                    #reminderDatePicker="ngbDatepicker"
                    appNgbDateInputMask
                  />
                  <button
                    type="button"
                    class="btn datepicker-button"
                    (click)="reminderDatePicker.toggle()"
                    aria-label="Open calendar"
                  >
                    <i class="bi bi-calendar"></i>
                  </button>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label class="form-label" requiredAsterisk for="qsb-dueDate">
                  Bid due date
                </label>
                <div class="input-group">
                  <input
                    id="qsb-dueDate"
                    class="form-control"
                    type="text"
                    placeholder="mm/dd/yyyy"
                    (ngModelChange)="bidDueDateChanged()"
                    [minDate]="BidDueMinDate"
                    formControlName="dueDate"
                    ngbDatepicker
                    container="body"
                    #dueDatePicker="ngbDatepicker"
                    appNgbDateInputMask
                  />
                  <button
                    type="button"
                    class="btn datepicker-button"
                    (click)="dueDatePicker.toggle()"
                    aria-label="Open calendar"
                  >
                    <i class="bi bi-calendar"></i>
                  </button>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label class="form-label" requiredAsterisk for="qsb-startDate">
                  Start date
                </label>
                <div class="input-group">
                  <input
                    id="qsb-startDate"
                    class="form-control"
                    type="text"
                    placeholder="mm/dd/yyyy"
                    [minDate]="BidStartMinDate"
                    formControlName="startDate"
                    ngbDatepicker
                    container="body"
                    #startDatePicker="ngbDatepicker"
                    appNgbDateInputMask
                  />
                  <button
                    type="button"
                    class="btn datepicker-button"
                    (click)="startDatePicker.toggle()"
                    aria-label="Open calendar"
                  >
                    <i class="bi bi-calendar"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </app-display-card>
      </div>
    </div>

    <!-- Pricing -->
    <div class="row mb-3">
      <div class="col">
        <app-display-card [innerPanel]="true">
          <div class="qsb-section-head">
            <h3 class="mb-0">Pricing</h3>
          </div>

          <div class="check-group mt-0">
            <input
              id="qsb-multiLine"
              class="form-check-input"
              type="checkbox"
              (change)="multiLineToggle()"
              formControlName="multiLine"
            />
            <label class="form-check-label mt-0" for="qsb-multiLine">
              Add line item requirements to bid request
            </label>
          </div>

          @if (ProposalRequestFormGroup.controls['multiLine'].value) {
            <div class="line-items mt-3">
              @for (
                ProposalRequestLineItemFormControl of ProposalRequestFormGroup
                  .controls['ProposalRequestLineItems'].controls;
                track ProposalRequestLineItemFormControl;
                let index = $index
              ) {
                <div class="line-item">
                  <span class="line-item__index">{{ index + 1 }}</span>
                  <input
                    class="form-control line-item__input"
                    type="text"
                    placeholder="Describe a line item the vendor should price"
                    [formControl]="
                      ProposalRequestLineItemFormControl.controls['text']
                    "
                  />
                  <button
                    type="button"
                    class="btn line-item__remove"
                    [disabled]="disableInput"
                    (click)="removeProposalRequestLineItem(index)"
                    aria-label="Remove line item {{ index + 1 }}"
                  >
                    <i class="bi bi-x-lg"></i>
                  </button>
                </div>
              }
              <div class="action-row justify-end mt-3">
                <button
                  type="button"
                  class="btn btn-outline"
                  (click)="addProposalRequestLineItem()"
                  [disabled]="disableInput"
                >
                  <i class="bi bi-plus-lg me-1"></i>
                  Add line item
                </button>
              </div>
            </div>
          }
        </app-display-card>
      </div>
    </div>

    <!-- Bid instructions -->
    <div class="row mb-3">
      <div class="col">
        <app-display-card [innerPanel]="true">
          <div class="qsb-section-head">
            <h3 class="mb-0">Bid instructions</h3>
          </div>
          <div class="form-group mb-0">
            <label class="form-label" for="qsb-instructions">
              Type and/or upload bid instructions
            </label>
            <textarea
              id="qsb-instructions"
              class="form-control"
              rows="10"
              formControlName="instructions"
            ></textarea>
          </div>
        </app-display-card>
      </div>
    </div>

    <!-- Bid documents -->
    <div class="row">
      <div class="col">
        <app-display-card [innerPanel]="true">
          <div class="qsb-section-head">
            <h3 class="mb-0">Bid documents</h3>
            <button
              type="button"
              class="btn btn-outline btn-sm"
              (click)="openFileSelectionModal()"
              [disabled]="disableInput"
            >
              Upload file(s)
            </button>
          </div>

          @if (
            ProposalRequestFormGroup.controls['ProposalRequestFiles'].controls
              .length === 0
          ) {
            <p class="text-secondary mb-0">No documents uploaded yet.</p>
          }

          @if (
            ProposalRequestFormGroup.controls['ProposalRequestFiles'].controls
              .length > 0
          ) {
            <div class="row g-3">
              @for (
                ProposalRequestFileFormControl of ProposalRequestFormGroup
                  .controls['ProposalRequestFiles'].controls;
                track ProposalRequestFileFormControl
              ) {
                <div class="col-md-6">
                  <div class="qsb-file-card">
                    <div class="qsb-file-card__row">
                      <span class="qsb-file-card__label">File name</span>
                      <a
                        href="javascript:void(0)"
                        (click)="
                          downloadProposalRequestFile(
                            ProposalRequestFileFormControl.value
                          )
                        "
                      >
                        {{
                          ProposalRequestFileFormControl.controls['File'].value
                            .filename
                        }}
                      </a>
                    </div>
                    <div class="qsb-file-card__row">
                      <span class="qsb-file-card__label">File size</span>
                      <span>
                        {{
                          ProposalRequestFileFormControl.controls['File'].value
                            .filesize
                        }}
                      </span>
                    </div>
                  </div>
                </div>
              }
            </div>
          }
        </app-display-card>
      </div>
    </div>
  </form>
}
